export default "__VITE_ASSET__CknfzBX6__"